<style scoped>

</style>
<template>
  <!--<prism-editor :code="code" language="sql" :lineNumbers="true" :autoStyleLineNumbers="true"></prism-editor>-->
  <ace-editor v-model="code" @init="editorInit" lang="sql" theme="chrome" width="100%" height="200"></ace-editor>
</template>
<script>
//  import VueAceEditor from 'vue2-ace-editor';
  import {createNamespacedHelpers} from 'vuex';
//  import 'brace/ext/language_tools';
//  import 'brace/mode/sql';
//  import 'brace/theme/chrome';
  const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('dataSources')

  export default {
    data: function() {
      return {
        code: "/** INSERT SQL BELOW **/"
      };
    },
    methods: {
        ...mapMutations(['mSetAceEditor']),
        editorInit: function (editor) {
          editor.setOptions({
            enableBasicAutocompletion: true
          });
          this.code = this.dataSource.input;
          this.mSetAceEditor(editor);
        }
    },
    computed: {
        ...mapState(['types', 'dataSources', 'dataSource'])
    },
    components: {
    //  'ace-editor': VueAceEditor
    }
  }
</script>
